export enum CoreTypes {
  CORE_ACCESS = 'core_access',
  CORE_PLUS = 'core_plus',
  CORE_PRO = 'core_pro',
  CORE_PRO_PLUS = 'core_pro_plus',
  CORE_MAX = 'core_max',
}
